import { Component } from '@angular/core';
import { HxAuthService, HxFioPipe } from 'hx-services';

@Component({
    selector: 'app-welcome',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.less'],
    imports: [HxFioPipe]
})
export class DashboardComponent {

  dateRange: Date[] = [];

  constructor(
    public auth: HxAuthService
  ) {
  }

  onChange(result: any): void {
    console.log('onChange: ', result);
  }

}
